import { useMemo, useState } from "react";
import { GridColDef } from "@mui/x-data-grid";
import { FilterDef, FilterOption } from "./filterDefs";
import { normalizeText, rowSearchText } from "../TableColumns/tableColumns";

export type FilterValues = Record<string, FilterOption | null>;

// Filtrado en el cliente para tablas con todas las filas cargadas: buscador
// por texto (en las columnas visibles, tal y como se muestran) y selectores.
// Devuelve las filas filtradas y las props para TableFilters.
export const useRowFilter = (rows: any[] | null, columns: GridColDef[], filters: FilterDef[] = []) => {
  const [search, setSearch] = useState("");
  const [filterValues, setFilterValues] = useState<FilterValues>({});

  const filteredRows = useMemo(() => {
    const words = normalizeText(search).split(/\s+/).filter(Boolean);
    return (rows ?? []).filter((row) => {
      const matchesFilters = filters.every((filter) => {
        const selected = filterValues[filter.id];
        return !selected || filter.getValue(row) === selected.value;
      });
      if (!matchesFilters) return false;
      if (words.length === 0) return true;
      const text = rowSearchText(row, columns);
      return words.every((word) => text.includes(word));
    });
  }, [rows, columns, filters, filterValues, search]);

  return {
    filteredRows,
    filterProps: {
      search,
      onSearchChange: setSearch,
      filters,
      values: filterValues,
      onFilterChange: (id: string, value: FilterOption | null) =>
        setFilterValues((current) => ({ ...current, [id]: value })),
      onClear: () => {
        setSearch("");
        setFilterValues({});
      },
      resultCount: filteredRows.length,
      totalCount: (rows ?? []).length,
    },
  };
};
